export const motorisedRollerBlinds = {
  overview: {
    titles: [
      "Phong cách và Chức năng",
      "Sự riêng tư",
      "Sự tiện lợi",
      "Tính linh hoạt",
    ],
    contents: [
      "Mành Cuốn có động cơ là sự lựa chọn tối ưu cho vẻ sang trọng, tinh tế và tiện lợi. Với vẻ ngoài lộng lẫy của Mành Cuốn, việc lắp đặt chúng nói không với bất cứ loại dây hay sự phức tạp nào. Bạn sẽ tận hưởng quyền kiểm soát hoàn toàn đối với sự vận hành của chúng bằng điều khiển từ xa, thiết bị trung tâm hay giọng nói của chính bạn.",
      "Một số chất liệu như Mành Cuốn kín mang đến cho bạn sự riêng tư tuyệt đối bất cứ khi nào bạn cần.",
      "Mành Cuốn có động cơ là phương án tiện lợi và dễ vận hành nhất cho bạn. Với điều khiển từ xa và động cơ hoạt động không gây ồn được lắp đặt ẩn / che đậy kỹ càng, bạn có thể dễ dàng đóng mở chúng. Việc đóng và mở Mành Cuốn thậm chí còn có thể được tự động hóa.",
      "Mành Cuốn có tính linh hoạt bởi chúng có khả năng che chắn nhiều cửa sổ cùng lúc hoặc từng cửa sổ lớn riêng lẻ. Chúng có thể được đồng bộ hóa, tách rời hay thậm chí vận hành theo một trình tự. Đối với Mành Cuốn được trang bị động cơ, chúng có thể hoạt động bằng pin có thể tái sạc hoặc nguồn điện lưới. Dù vận hành bằng cách nào thì việc điều khiển Mành Cuốn vẫn là một công việc đơn giản.",
    ],
  },
  description: {
    titles: ["", ""],
    contents: [
      "Mành Cuốn có động cơ là sự lựa chọn tối ưu cho vẻ sang trọng, tinh tế và tiện lợi. Với vẻ ngoài lộng lẫy của Mành Cuốn, việc lắp đặt chúng nói không với bất cứ loại dây hay sự phức tạp nào. Bạn sẽ tận hưởng quyền kiểm soát hoàn toàn đối với sự vận hành của chúng bằng điều khiển từ xa, thiết bị trung tâm hay giọng nói của chính bạn.",
      "Động cơ của Mành Cuốn được lắp đặt bên trong ống của chúng nên nó được che đậy hoàn toàn. Hơn nữa, động cơ của mành không yêu cầu bạn phải vệ sinh chúng. Chính vì thế, toàn bộ Mành Cuốn của chúng tôi bao gồm mành kín, mành cách nhiệt, mành chống nắng, mành lọc ánh sáng hay Mành Cuốn kép đều có thể được động cơ hóa.",
      "Không những thế, mành động cơ của chúng tôi không yêu cầu dây vì chúng không cần phải kết nối điện. Chúng được vận hành bằng pin. Bạn có thể lựa chọn sạc chúng bằng năng lượng mặt trời hay cáp USB. Tuy thời gian sạc mành động cơ lên đến tám tiếng, việc đóng mở mành có thể được thực hiện lên tới 500 lần chỉ với một lần sạc.",
    ],
  },
  summary: {
    header:
      "Simple and stylish, roller blinds are our most popular product. They’re easy to operate and maintain, and come in a number of colour ways and fabrics.",
    subItems: [
      {
        title: "BLOCKOUT ROLLER BLINDS",
        details:
          "Prevent sun light from entering any room with the specifically engineered blackout roller blinds. They’re great for optimum sleep or privacy. And parents swear by then for establishing the right sleep patterns in small children. We offer thermal blockout options to regulate heat in a room so you’re cozy in winter or cool in summer.",
      },
      {
        title: "SUNSCREEN ROLLER BLINDS",
        details:
          "Sunscreen roller blinds have a dual benefit. They cut out sunlight for glare control and provide shade to protect furnishings from harmful UV. Because they are semi-transparent you can also maintain your view while achieving privacy and light control. Available in either 3%, 5% of 10% screen, simply choose the best option for your needs.",
      },
      {
        title: "COMBINATION ROLLER BLINDS",
        details:
          "Consider combining blockout and sunscreen roller blinds on the same window to achieve the best of both worlds – complete darkness when you need it and a glare-protected view during the day.",
      },
      {
        title: "MOTORISED FOR EASE",
        details:
          "Window Answers’ roller blinds can be motorised for ease. This is a great solution if you have a large area of blinds or blinds which are difficult to access.",
      },
    ],
  },
  about: {
    header: "What we say about Roller blinds",
    col01: {
      title: "Great for…",
      items: [
        "Reducing light in bedrooms with blackout fabrics",
        "Kitchens and bathrooms with water resistant finishes",
        "Hard to reach windows or multiple blinds with motorised options",
        "Perfect Fit frames, giving a streamlined finish",
        "Skylight windows",
      ],
    },
    col02: {
      title: "Things to consider",
      items: [
        "Roller blinds are made from one piece of fabric, so they can’t be shaped around sloping or unusual windows",
        "All our Roller blinds are chain or pull-cord operated, and our advisors will fit child safety cleats as standard. Alternatively, Perfect Fit or motorised Roller blinds are cordless",
        "For a drill-free option, choose Perfect Fit blinds, which clip into your uPVC frames",
      ],
    },
  },
};
